import { useCallback } from 'react';
import { prop } from 'ramda';
import { TPlayerStatisticType } from 'js/hooks/socket/types';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetPlayerLifetimeStatistics = () => {
    const send = useGenericSend();
    const clientType = useAppSelector(prop('clientType'));
    const clientPlatform = useDeviceSelector(prop('clientPlatform'));

    return useCallback(async (statisticsTypes: TPlayerStatisticType[]) => {
        const { data } = await send<Types.IGetPlayerLifetimeStatisticsRequestData, Types.IGetPlayerLifetimeStatisticsResponse>({
            ID: 32032,
            description: 'Get Player Lifetime Statistics',
            responses: [32033, 32034],
            statisticsTypes,
            clientType,
            clientPlatform
        });

        return data.statisticsList;
    }, [send, clientType, clientPlatform]);
};
